import axios from "axios";
import logger from "../../../utils/logger";
import * as uiActions from "../reducer/ui";
import {
  addUser,
  loadLocalUser,
  loadUser,
  loadUsers,
  loadUsersSuccess,
  loadUserSuccess,
  login,
  loginSuccess,
  logout,
  removeUser,
  setToken,
} from "../reducer/user";

const doLoginFlow =
  ({ performLogin }) =>
  ({ dispatch, getState }) =>
  (next) =>
  async (action) => {
    next(action);
    if (action.type === login.type) {
      dispatch(uiActions.setLoading(true));
      try {
        const response = await performLogin(action.payload.data);
        dispatch(loginSuccess(response.data));
        logger()(response.data);
        if (action.payload.remember) {
          localStorage.setItem("token", response.data.data.token);
        }
        axios.defaults.headers.common["x-auth-token"] =
          response.data.data.token;
        dispatch(loadUser());
      } catch (error) {
        if (error.response && error.response.data && error.response.data.msg) {
          dispatch(uiActions.setError(error.response.data.msg));
        } else dispatch(uiActions.setError(error.message));
      }
      dispatch(uiActions.setLoading(false));
    }
  };

const loadLocalUserFlow =
  () =>
  ({ dispatch, getState }) =>
  (next) =>
  async (action) => {
    next(action);
    if (action.type === loadLocalUser.type) {
      dispatch(uiActions.setLoading(true));
      try {
        const token = localStorage.getItem("token");
        logger()(token);
        if (token) {
          axios.defaults.headers.common["x-auth-token"] = token;
          dispatch(setToken(token));
          dispatch(loadUser());
        }
      } catch (error) {
        if (error.response && error.response.data && error.response.data.msg) {
          dispatch(uiActions.setError(error.response.data.msg));
        } else dispatch(uiActions.setError(error.message));
      }
      dispatch(uiActions.setLoading(false));
    }
  };

const loadUserFlow =
  ({ getUser }) =>
  ({ dispatch, getState }) =>
  (next) =>
  async (action) => {
    next(action);
    if (action.type === loadUser.type) {
      dispatch(uiActions.setLoading(true));
      try {
        const response = await getUser();
        dispatch(loadUserSuccess(response.data));
        logger()(response.data);
      } catch (error) {
        if (error.response && error.response.data && error.response.data.msg) {
          dispatch(uiActions.setError(error.response.data.msg));
        } else dispatch(uiActions.setError(error.message));
      }
      dispatch(uiActions.setLoading(false));
    }
  };

const deleteUserFlow =
  ({ deleteUser }) =>
  ({ dispatch, getState }) =>
  (next) =>
  async (action) => {
    next(action);
    if (action.type === removeUser.type) {
      dispatch(uiActions.setLoading(true));
      try {
        const response = await deleteUser(action.payload);
        logger()(response.data.msg);
        dispatch(uiActions.setToast(response.data.msg));
      } catch (error) {
        if (error.response && error.response.data && error.response.data.msg) {
          dispatch(uiActions.setError(error.response.data.msg));
        } else dispatch(uiActions.setError(error.message));
      }
      dispatch(uiActions.setLoading(false));
    }
  };

const logoutFlow =
  () =>
  ({ dispatch, getState }) =>
  (next) =>
  async (action) => {
    next(action);
    if (action.type === logout.type) {
      dispatch(uiActions.setLoading(true));
      try {
        localStorage.removeItem("token");
        delete axios.defaults.headers.common["x-auth-token"];
      } catch (error) {
        if (error.response && error.response.data && error.response.data.msg) {
          dispatch(uiActions.setError(error.response.data.msg));
        } else dispatch(uiActions.setError(error.message));
      }
      dispatch(uiActions.setLoading(false));
    }
  };

const loadUsersFlow =
  ({ getAllUser }) =>
  ({ dispatch, getState }) =>
  (next) =>
  async (action) => {
    next(action);
    if (action.type === loadUsers.type) {
      dispatch(uiActions.setLoading(true));
      try {
        const response = await getAllUser();
        dispatch(loadUsersSuccess(response.data));
        logger()(response.data);
      } catch (error) {
        if (error.response && error.response.data && error.response.data.msg) {
          dispatch(uiActions.setError(error.response.data.msg));
        } else dispatch(uiActions.setError(error.message));
      }
      dispatch(uiActions.setLoading(false));
    }
  };

const addUserFlow =
  ({ registerUser, rootRegisterUser }) =>
  ({ dispatch, getState }) =>
  (next) =>
  async (action) => {
    next(action);
    if (action.type === addUser.type) {
      dispatch(uiActions.setLoading(true));
      try {
        let response;
        if (action.payload.type === "root") {
          response = await rootRegisterUser(action.payload);
        } else {
          response = await registerUser(action.payload);
        }
        logger()(response.data);
        dispatch(uiActions.setToast("User Added type: " + action.payload.type));
        dispatch(loadUsers());
      } catch (error) {
        if (error.response && error.response.data && error.response.data.msg) {
          dispatch(uiActions.setError(error.response.data.msg));
        } else dispatch(uiActions.setError(error.message));
      }
      dispatch(uiActions.setLoading(false));
    }
  };

const userFlow = [
  doLoginFlow,
  loadUserFlow,
  loadUserFlow,
  addUserFlow,
  loadUsersFlow,
  loadLocalUserFlow,
  logoutFlow,
  deleteUserFlow,
];

export default userFlow;
